<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ action }}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('common_198')" :count="params.data.length" :action="action" />
      <dialog-table :data="params.data" :columns="columns" />
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item :label="$t('common_351')">
          <a-radio-group v-decorator="decorators.isResove">
            <a-radio :value="true">{{$t('common_352')}}</a-radio>
            <a-radio :value="false">{{$t('common_353')}}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('common_354')">
          <a-textarea :placeholder="$t('common_355')" v-decorator="decorators.remarks" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import {
  getProcessDefinitionNameTableColumn,
  // getResourceNameTableColumn,
  getInitiatorTableColumn,
  getCommentTableColumn,
} from '../../utils/columns'
const R = require('ramda')

export default {
  name: 'WorkflowSupportEndDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      action: this.$t('common_356'),
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        isResove: [
          'isResove',
          { initialValue: true },
        ],
        remarks: [
          'remarks',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      columns: [
        getProcessDefinitionNameTableColumn({ field: 'process_instance.process_definition_name' }),
        // getResourceNameTableColumn({ title: this.$t('common_357') }),
        getInitiatorTableColumn({ field: 'process_instance.start_user_name' }),
        getCommentTableColumn({ title: this.$t('common_157'), field: 'process_instance.comment' }),
      ],
    }
  },
  computed: {
    selectedItems () {
      return this.params.data
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const ids = this.params.data.map(item => item.id || (item.process_instance && item.process_instance.id))
        const values = await this.form.fc.validateFields()
        const params = {
          delete_reason: values.isResove ? `${this.$t('common_358')}: ${values.remarks || this.$t('common_456')}` : `${this.$t('common_359')}: ${values.remarks || this.$t('common_457')}`, // 审批意见
        }
        const res = await new this.$Manager('process-instances', 'v1').batchDelete({
          ids,
          params,
        })
        const isOk = res.data.data.every(item => item.status === 200)
        if (isOk) {
          if (this.params.success && R.is(Function, this.params.success)) {
            this.params.success(res)
          }
          this.$message.success(this.$t('common_360'))
        }
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
